import React, { Component } from 'react';
import classNames from 'classnames';
import Button from '../../components/Button/Button';
import './dp-pull-out-panel.scss';
import WithTransition from '../../hoc/WithTransition';

class PullOutPanel extends Component {
	render() {
		const mainClass = classNames({
			[this.props.classBEMRoot]: this.props.classBEMRoot,
			[this.props.className]: this.props.className,
			[`${this.props.classBEMRoot}--disabled`]: this.props.disabled,
		});

		const dropDownClass = classNames({
			[`${this.props.classBEMRoot}__drop-down`]: true,
			[`${this.props.classBEMRoot}__drop-down--active`]: this.props.dropDownActive || this.props.disabled,
			[`${this.props.classBEMRoot}__drop-down--keep-target-ctrl`]: this.props.keepTargetCtrl,
		});

		return (
			<div className={mainClass} ref={this.props.panelRef}>
				<div className={dropDownClass} onClick={this.props.onBackDropClick} />
				<Button
					active
					classBEMRoot={`${this.props.classBEMRoot}__close-button`}
					onClick={this.props.onCloseClick}
				/>
				<div dangerouslySetInnerHTML={{ __html: this.props.title }} className={`${this.props.classBEMRoot}__title`}></div>
				{this.props.children}
			</div>
		);
	}
}

export default WithTransition(PullOutPanel);
